import styled from 'styled-components'

export const StyledPropertyInfoContainer = styled.div`
  max-height: 230px;
  overflow-y: auto;
  overflow-x: hidden;
  padding-right: 10px;
  margin-top: 12px;
  ::-webkit-scrollbar {
    width: 8px;
  }
  ::-webkit-scrollbar-track {
    background: none;
  }
  ::-webkit-scrollbar-thumb {
    background: #c8cbcd;
    border-radius: 5px;
  }
  ::-webkit-scrollbar-thumb:hover {
    background: #555;
  }
`

export const StyledSectionContainer = styled.div`
  display: flex;
  padding-top: 12px;
  flex-direction: column;
`

export const StyledHeader = styled.div`
  font-weight: 600;
  font-size: 14px;
  line-height: 24px;
  color: #495057;
`

export const StyledDataContainer = styled.div`
  display: flex;
  padding-top: 8px;
  flex-direction: row;
  gap: 20px;
`

export const StyledDataColumn = styled.div`
  flex: 1;
`

export const StyledDataProperty = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  gap: 10px;
`

export const StyledPropertyLabel = styled.div`
  flex: 1;
  font-weight: 400;
  font-size: 12px;
  line-height: 20px;
  color: #495057;
`

export const StyledPropertyValue = styled.div`
  display: flex;
  align-content: center;
  flex: 1;
  font-weight: 600;
  font-size: 12px;
  line-height: 20px;
  color: #495057;

  img {
    margin-left: -3px;
    margin-right: 5px;
    height: 20px;
  }
`

export const StyledLine = styled.div`
  width: 100%;
  border: 1px solid #7c7c7b;
  opacity: 0.2;
  margin-top: 10px;
`
